export class ConsentForm {
    CompanyID: string;
    StoreNo: string;
    PartAName: string;
    NationalID: string;
    Phone: string;
    Address: string;
    Email: string;
    Contact: string;
    ContactTel: string;
    Hospital: string;
    PetName: string;
    PetVarity: string;
    SignatureTime: string;
    SignaturePath: string;
    Type: string;
    constructor() {
        this.CompanyID = '';
        this.StoreNo = '';
        this.PartAName = "";
        this.NationalID = "";
        this.Address = "";
        this.Phone = "";
        this.Contact = "";
        this.Email = "";
        this.ContactTel = "";
        this.Hospital = "";
        this.PetName = "";
        this.PetVarity = "";
        this.SignatureTime = "";
        this.SignaturePath = "";
        this.Type = "";
    }
}